import React from 'react'
import InstancesPanel from './InstancesPanel'

import { INSTANCE_TYPE } from 'pages/Administration/constants'

const DocumentInputTab = ({ admin }) => (
  <div className='role-view'>
    <div className='children-view'>
      <InstancesPanel admin={admin} instanceType={INSTANCE_TYPE.INSTANCE} />
    </div>
  </div>
)

export default DocumentInputTab
